module.exports = __webpack_public_path__ + "img/Thai.1044d68c.jpeg";